<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-encrypted-chat`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.5 24a7.5 7.5 0 017.5 7.5V33h2a1 1 0 011 1v12a1 1 0 01-1 1H26a1 1 0 01-1-1V34a1 1 0 011-1h2v-1.5a7.5 7.5 0 017.5-7.5zM42 37H29v6h13v-6zM22 4c9.717 0 17.636 7.7 17.988 17.331a9.932 9.932 0 00-4.125-1.294C34.909 13.235 29.066 8 22 8 14.268 8 8 14.268 8 22v14h13v4H6a2 2 0 01-2-2V22c0-9.941 8.059-18 18-18zm13.5 24a3.5 3.5 0 00-3.495 3.308L32 31.5V33h7v-1.5a3.5 3.5 0 00-3.5-3.5zM20 25a1 1 0 011 1v2a1 1 0 01-1 1h-5a1 1 0 01-1-1v-2a1 1 0 011-1h5zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h13z"/></svg>
</template>
<script>

export default {
  name: 'IconEncryptedChat',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
